import { TimeBucket } from '@/Enums/ReportBuilder/TimeBucket.enum';
import { TIME_LABELS } from '@/constants/reportBuilder';
import { formatToColumns } from '@/helpers/reportBuilder';
import { PreviewGridColumnSource } from '@/types/ReportBuilder/PreviewGridColumn.types';
import { GridColDef } from '@mui/x-data-grid-pro';

export const getGridColumns = (columns: PreviewGridColumnSource[]) =>
  [
    {
      field: 'timeBucket',
      headerName: 'Time Period',
      valueFormatter: (value: TimeBucket) => TIME_LABELS[value],
    },
    columns.map(option => formatToColumns(option)),
  ].flat() as GridColDef[];

export const getAllColumnsHiddenModel = (columns: PreviewGridColumnSource[] = []) =>
  Object.fromEntries([
    ...columns.map(column => {
      return [column.value, false];
    }),
    ['timeBucket', false],
  ]);
